'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.function.name')
require('core-js/modules/es.object.keys')
require('core-js/modules/es.string.includes')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var Val = /*#__PURE__*/ (function() {
  function Val(name) {
    ;(0, _defineProperty2.default)(this, 'name', 'unknown val')
    ;(0, _defineProperty2.default)(this, '_type', void 0)
    ;(0, _defineProperty2.default)(this, '_isRequired', false)
    ;(0, _defineProperty2.default)(this, '_fillIfNot', true)
    ;(0, _defineProperty2.default)(this, '_defaultVal', void 0)
    ;(0, _defineProperty2.default)(this, '_arrItem', void 0)
    ;(0, _defineProperty2.default)(this, '_props', void 0)
    if ((0, _is.isStr)(name)) {
      this.name = name
    }
  }
  Val.define = function define(name) {
    return new Val(name)
  }
  Val.err = function err(msg) {
    throw new Error(msg)
  }
  var _proto = Val.prototype
  _proto._checkTypeSetting = function _checkTypeSetting() {
    if (this._isTypeSetted) {
      Val.err(this.name + ' is allready have a type')
    }
  }
  _proto.default = function _default(val) {
    this._defaultVal = val
    return this
  }
  _proto.hasItems = function hasItems(val) {
    if (this._type !== 'array') {
      throw new Error(this.name + ' is not an array to contains array items')
    }
    this._arrItem = val
    return this
  }
  _proto.hasProperties = function hasProperties(props) {
    if (this._type !== 'object') {
      throw new Error(this.name + ' is not an object to have properties')
    }
    this._props = props
    return this
  }
  _proto._collect = function _collect() {
    var name = this.name
    var type = this._type

    if (!(0, _is.isStr)(type) || !Val.availableTypes.includes(type)) {
      Val.err('type is not setted or wrong for val ' + name)
    }

    // debugger // eslint-disable-line no-debugger

    var isRequired = this._isRequired
    var hasDefault =
      Object.prototype.hasOwnProperty.call(this, '_defaultVal') && this._defaultVal !== undefined
    var fillIfNot = this._fillIfNot === true

    // if ( hasDefault && fillIfNot ) {
    //   Val.err( `you dont't need to set together default value and cast value for ${name}` )
    // }

    var result = {
      name: name,
      type: type,
      isRequired: isRequired,
      hasDefault: hasDefault,
      fillIfNot: fillIfNot
    }

    if (hasDefault) {
      var def = this._defaultVal
      // $FlowFixMe
      result.defaultVal = (0, _is.isF)(def) ? def() : def
    }

    if (type === 'object') {
      if (!(0, _is.isObj)(this._props)) {
        Val.err(name + ' is object but for it not defined properties')
      } else {
        var pr = this._props
        Object.keys(pr).forEach(function(propKey) {
          if (!(pr[propKey] instanceof Val)) {
            Val.err('property ' + propKey + ' for object ' + name + ' is wrong defined')
          }
        })
        result.props = pr
      }
    }

    if (type === 'array') {
      if (!(this._arrItem instanceof Val)) {
        Val.err(name + ' is array but it items type is not defined')
      } else {
        result.arrItem = this._arrItem
      }
    }

    return result
  }

  //
  // Short creating Val aliases
  //
  Val.str = function str(name) {
    return Val.define(name).string
  }
  Val.num = function num(name) {
    return Val.define(name).number
  }
  Val.bool = function bool(name) {
    return Val.define(name).boolean
  }
  Val.arr = function arr(name, arrItem) {
    var arrVal = Val.define(name).array
    if (arrItem instanceof Val) {
      return arrVal.hasItems(arrItem)
    }
    return arrVal
  }
  Val.obj = function obj(name, props) {
    var objVal = Val.define(name).object
    if ((0, _is.isObj)(props)) {
      return objVal.hasProperties(props)
    }
    return objVal
  }
  ;(0, _createClass2.default)(
    Val,
    [
      {
        key: '_isTypeSetted',
        get: function get() {
          return (0, _is.isStr)(this._type)
        }
      },
      {
        key: 'required',
        get: function get() {
          this._isRequired = true
          return this
        }
      },
      {
        key: 'string',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'string'
          return this
        }
      },
      {
        key: 'number',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'number'
          return this
        }
      },
      {
        key: 'boolean',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'boolean'
          return this
        }
      },
      {
        key: 'object',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'object'
          return this
        }
      },
      {
        key: 'array',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'array'
          return this
        } // TODO: move
      },
      {
        key: 'null',
        get: function get() {
          this._checkTypeSetting()
          this._type = 'null'
          return this
        }
      },
      {
        key: 'dontFill',
        get: function get() {
          this._fillIfNot = false
          return this
        }
      }
    ],
    [
      {
        key: 'availableTypes',
        get: function get() {
          return ['string', 'number', 'boolean', 'object', 'array', 'null']
        }
      }
    ]
  )
  return Val
})()
var _default2 = Val
exports.default = _default2



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/getValidVal/Val.js
// module id = 636
// module chunks = 0